module.exports = __webpack_public_path__ + "static/media/logo.6fd4e942.PNG";